import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import getCurrencySymbol from "../../utils/getCurrencySymbol";
import StatsSummaryCard from "../shared/StatsSummaryCard";

const currency = "EUR";
interface StateSummaryProps {
  activeClients: number;
  totalPendingPayouts: number;
  totalCollectedPayouts: number;
}

const StateSummary = ({ activeClients, totalPendingPayouts, totalCollectedPayouts }: StateSummaryProps) => {
  const { t } = useTranslation("stats", { keyPrefix: "distributorSummary" });

  // Note: 'currency' is a module-level constant
  const symbol = useMemo(() => getCurrencySymbol(currency), []);

  const stats = [
    { title: t("activeClients"), stat: activeClients || 0 },
    { title: t("totalPendingPayouts"), stat: `${(totalPendingPayouts || 0).toFixed(2)} ${symbol}` },
    { title: t("totalCollectedPayouts"), stat: `${(totalCollectedPayouts || 0).toFixed(2)} ${symbol}` },
  ];

  return (
    <StatsSummaryCard
      mainStat={`${((totalPendingPayouts || 0) + (totalCollectedPayouts || 0)).toFixed(2)} ${symbol}`}
      mainTitle={t("totalCollectedPayouts")}
      stats={stats}
      color="primary text-white"
    />
  );
};

export default StateSummary;
